import { useTranslation } from 'react-i18next'

export function useDWPStates() {
    const { t } = useTranslation(['user', 'companyRecord'])

    const DEStates = {
        VALID: {
            id: 'Valide',
            label: t('companyRecord:validated'),
            icon: 'thumb_up_alt',
            color: '#4CAF50',
        },
        WAITING: {
            id: 'Brouillon',
            label: t('companyRecord:draft'),
            icon: 'watch_later',
            color: '#F5960A',
        },
        WRITING: {
            id: 'Refusé',
            label: t('companyRecord:rejected'),
            icon: 'create',
            color: '#F5960A',
        },
        REVIVE: {
            id: 'Soumis',
            label: t('companyRecord:submitted'),
            icon: 'autorenew',
            color: '#3399ff',
        },
    }

    const VDWP = {
        AUTO: {
            id: 'Automatic',
            label: t('user:Automatic'),
            icon: 'autorenew',
            color: '#006946',
        },
        DEROGATION: {
            id: 'Derog',
            label: t('user:Derogation'),
            icon: 'redo',
            color: '#F5960A',
        },
        BANNED: {
            id: 'Forbidden',
            label: t('user:Prohibited'),
            icon: 'remove_circle_outline',
            color: '#F44436',
        },
    }

    const IDWP = {
        AUTO: {
            id: 'Received',
            label: t('user:Receive'),
            icon: 'checked_circle',
            color: '#006946',
        },
        DEROGATION: { id: 'Sent', label: t('user:DWPsend'), icon: 'send', color: '#F5960A' },
        BANNED: {
            id: 'NotIssued',
            label: t('user:notSend'),
            icon: 'portable_wifi_off',
            color: '#888888',
        },
        ERROR: {
            id: 'Failed',
            label: t('user:ErrorSend'),
            icon: 'error',
            color: '#F44436',
        },
    }

    const findById = (states, id) => Object.values(states).find((s) => s.id === id)

    const findVDWPById = (id) => findById(VDWP, id)

    const findIDWPById = (id) => findById(IDWP, id)

    const findStateById = (id) => findById(DEStates, id)

    return { DEStates, findStateById, VDWP, IDWP, findVDWPById, findIDWPById }
}
